import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {Button} from "../styles/Button";
import { FaDiscord, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <Wrapper>

     <section className='contact-short'>
      <div className='grid grid-two-column'>
       <div>
        <h3>Ready to Get Started</h3>
        <h3>Talk to us directly</h3>
       </div>
       <div>
        <NavLink to = "/">
          <Button>Get Started</Button>
        </NavLink>
       </div>
      </div>
      </section>
      <footer>
      <div className='container grid grid-four-column'>
        <div className='footer-about'>
          <h3>Colglin</h3>
          <p> A kind of social media but specific to college</p>
        </div>
        <div className='footer-subscribe'>
          <h3>Subscribe to get Important updates</h3>
          <form action="#">
           <input type="email" placeholder="Email" name= "Email" autoComplete="off" required/>
           <input type="submit" value ="Subscribe"/>
          </form>
                    
        </div>
        <div>
          <h3>Follow us</h3>
          <div  className='footer-social-icons'>
          <div>
            <FaDiscord className='icons'/>
            
          </div>
          <div>
            <FaInstagram className='icons'/>
            
          </div>
          <div>
            <FaYoutube className='icons'/>
            
          </div></div>
        </div>
        <div>
          <h3>Call us</h3>
          <h3>+91 123456789</h3>
        </div>
      </div>
      <div className='footer-bottom--section'>
     <hr/>
      <div className='container grid grid-two-column'>
        
          <p> ⓒ2022 ColgLin. All Rights Reserved </p>
        

        <div>
          <h3>Privacy and Policy</h3> 
          <h3> Terms and Conditions</h3>
        </div>
      </div>
      </div>
      </footer>

    </Wrapper>
  )
}

const Wrapper = styled.section`
.top{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contact-short{
  max-width: 60vw;
  margin: auto;
  padding: 5rem 10rem;
  background-color: ${({theme})=> theme.colors.bg};
  border-radius: 1rem;
  box-shadow: ${({theme})=> theme.colors.shadowSupport};
  transform: translateY(50%);

}

.grid div:last-child{
  justify-self: end;
  align-self: center;
}

footer{ 
  padding: 14rem 0 9rem 0;
  background-color: ${({theme})=>theme.colors.footer_bg};

  h3{
    color: ${({theme})=>theme.colors.hr};
    margin-bottom: 2.4rem;
  }

  p{
    color: ${({theme})=>theme.colors.white};
  }

  .footer-social-icons{
    display:flex;
    gap:2rem;

    div{
      padding: 1rem;
      border-radius:50%;
      border: 2px solid ${({theme})=>theme.colors.white};
      align-self: center;

      .icons{
        color:${({theme})=>theme.colors.white};
        font-size:2.4rem;
        position: relative;
        cursor: pointer;
      }
      
    }
  }

  .footer-bottom--section{
        padding-top: 9rem;
        hr{
          magin-bottom: 2rem;
          color: ${({theme})=> theme.colors.hr};
          height: 0.1px;
        }
        h3{
          margin-top:1rem;
        }
      }
}

@media (max-width: ${({theme})=> theme.media.mobile}){

  html{
    font-size:50%;
  }

    .contact-short{
      max-width: 95vw;
      padding: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: center; 
      align-item: center;
    }

    footer .footer-bottom--section{
      padding-bottom: 2rem;
      padding-top: 2rem;
    }
    .grid div:last-child {
        justify-self: start;
    }
    form{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      input, textarea {
        max-width: 30rem;
      }
      input[type="submit"] {
        max-width: 17rem;

    }
}
`;

export default Footer